/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Section: Form Toggle
 * ------------------------------------------------------------------------------
 * This handles the form toggle modal functionality
 *
 * @namespace FormToggle
 */
var FormToggle = /*#__PURE__*/function () {
  function FormToggle(element) {
    _classCallCheck(this, FormToggle);
    this.section = element;
    this.formId = this.section.dataset.formId;

    // Debug mode for custom events
    this.debugMode = false; // Set to false to disable event logging

    // Scope the selectors to the current section
    this.triggers = this.section.querySelectorAll('[js-form-toggle="toggleTrigger"]');
    this.modal = this.section.querySelector('[js-form-toggle="modal"]');
    this.closeButton = this.section.querySelector('.form-toggle__close');
    this.overlay = this.section.querySelector('.form-toggle__modal-overlay');

    // Bind the handlers to preserve context
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleCustomEvent = this.handleCustomEvent.bind(this);
    this.init();
  }
  return _createClass(FormToggle, [{
    key: "init",
    value: function init() {
      if (this.triggers && this.modal) {
        this.addEventListeners();
        this.setupCustomEventListeners();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target === this.closeButton || event.target.closest('.form-toggle__close')) {
        this.closeModal();
      } else {
        this.toggleModal();
      }
    }
  }, {
    key: "handleOverlayClick",
    value: function handleOverlayClick(event) {
      if (event.target === this.overlay) {
        this.closeModal();
      }
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      // Close modal on Escape key
      if (event.key === 'Escape' && !this.modal.classList.contains('hidden')) {
        this.closeModal();
      }
    }
  }, {
    key: "toggleModal",
    value: function toggleModal() {
      var isHidden = this.modal.classList.contains('hidden');
      if (isHidden) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.modal.classList.remove('hidden');
      document.body.classList.add('modal-open');
      document.addEventListener('keydown', this.handleKeydown);

      // Focus management
      this.setFocus();

      // Announce to screen readers
      this.announceToScreenReader('Modal opened');

      // Dispatch custom event for modal open
      this.dispatchCustomEvent('formToggle:modalOpened', {
        formId: this.formId,
        modal: this.modal,
        section: this.section
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modal.classList.add('hidden');
      document.body.classList.remove('modal-open');
      document.removeEventListener('keydown', this.handleKeydown);

      // Return focus to trigger button
      this.returnFocus();

      // Announce to screen readers
      this.announceToScreenReader('Modal closed');

      // Dispatch custom event for modal close
      this.dispatchCustomEvent('formToggle:modalClosed', {
        formId: this.formId,
        modal: this.modal,
        section: this.section
      });
    }
  }, {
    key: "dispatchCustomEvent",
    value: function dispatchCustomEvent(eventName) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var event = new CustomEvent(eventName, {
        detail: _objectSpread(_objectSpread({}, detail), {}, {
          timestamp: Date.now(),
          source: 'FormToggle'
        }),
        bubbles: true,
        cancelable: true
      });

      // Dispatch on multiple targets
      this.section.dispatchEvent(event);
      document.dispatchEvent(event);
      if (this.debugMode) {
        console.log("\uD83D\uDCE1 Dispatched custom event: ".concat(eventName), detail);
      }
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      // Focus the first focusable element in the modal
      var focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }, {
    key: "returnFocus",
    value: function returnFocus() {
      // Return focus to the trigger button that opened the modal
      var triggerButton = this.section.querySelector('[js-form-toggle="toggleTrigger"]:not(.form-toggle__modal-overlay):not(.form-toggle__close)');
      if (triggerButton) {
        triggerButton.focus();
      }
    }
  }, {
    key: "announceToScreenReader",
    value: function announceToScreenReader(message) {
      // Create a temporary element to announce to screen readers
      var announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.style.position = 'absolute';
      announcement.style.left = '-10000px';
      announcement.style.width = '1px';
      announcement.style.height = '1px';
      announcement.style.overflow = 'hidden';
      announcement.textContent = message;
      document.body.appendChild(announcement);

      // Remove the announcement element after a short delay
      setTimeout(function () {
        if (announcement.parentNode) {
          announcement.parentNode.removeChild(announcement);
        }
      }, 1000);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this = this;
      // Add click listeners to all triggers
      this.triggers.forEach(function (trigger) {
        trigger.addEventListener('click', _this.handleClick);
      });

      // Add overlay click listener
      if (this.overlay) {
        this.overlay.addEventListener('click', this.handleOverlayClick);
      }
    }
  }, {
    key: "setupCustomEventListeners",
    value: function setupCustomEventListeners() {
      // Set up global event interception to catch ALL custom events
      if (this.debugMode) {
        this.interceptAllCustomEvents();
      }
    }
  }, {
    key: "handleCustomEvent",
    value: function handleCustomEvent(event) {
      // Log ALL custom events globally
      if (this.debugMode) {
        console.group("\uD83C\uDF0D Global Custom Event Detected: ".concat(event.type));
        console.log('Event:', event);
        console.log('Target:', event.target);
        console.log('Detail:', event.detail);
        console.log('Current URL:', window.location.href);
        console.log('Timestamp:', new Date().toISOString());

        // Show the call stack to understand where the event came from
        console.log('Call Stack:', new Error().stack);

        // If the event has custom properties, log them
        if (event.detail) {
          console.log('Event Detail:', JSON.stringify(event.detail, null, 2));
        }
        console.groupEnd();
      }

      // You can add specific event handling here if needed
      // This is just a global listener to catch everything
    }
  }, {
    key: "interceptAllCustomEvents",
    value: function interceptAllCustomEvents() {
      // Store reference to the original methods
      var originalAddEventListener = EventTarget.prototype.addEventListener;
      var originalDispatchEvent = EventTarget.prototype.dispatchEvent;
      var formToggleInstance = this;

      // Intercept addEventListener to see what events are being registered
      EventTarget.prototype.addEventListener = function (type, listener, options) {
        // Log any custom event listener being added (contains colon or common plugin names)
        if (formToggleInstance.debugMode && (type.includes(':') || type.includes('form') || type.includes('modal') || type.includes('popup') || type.includes('klaviyo') || type.includes('globo') || type.includes('mailchimp') || type.includes('hubspot') || type.includes('typeform') || type.includes('submit') || type.includes('success') || type.includes('error') || type.includes('load'))) {
          console.log("\uD83C\uDFAF Event listener registered: ".concat(type), {
            target: this,
            element: this.tagName || this.constructor.name,
            id: this.id,
            className: this.className
          });
        }

        // Call the original addEventListener
        return originalAddEventListener.call(this, type, listener, options);
      };

      // Intercept dispatchEvent to catch ALL custom events being fired
      EventTarget.prototype.dispatchEvent = function (event) {
        // Log ALL custom events (not just standard DOM events)
        if (formToggleInstance.debugMode && (event.type.includes(':') || event.type.includes('form') || event.type.includes('modal') || event.type.includes('popup') || event.type.includes('klaviyo') || event.type.includes('globo') || event.type.includes('mailchimp') || event.type.includes('hubspot') || event.type.includes('typeform') || event.type.includes('submit') || event.type.includes('success') || event.type.includes('error') || event.type.includes('load') || event.constructor.name === 'CustomEvent')) {
          formToggleInstance.handleCustomEvent(event);
        }

        // Call the original dispatchEvent
        return originalDispatchEvent.call(this, event);
      };

      // Store references for cleanup
      this.originalAddEventListener = originalAddEventListener;
      this.originalDispatchEvent = originalDispatchEvent;

      // Also set up a global mutation observer to watch for inline event handlers
      if (window.MutationObserver) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName && mutation.attributeName.startsWith('on')) {
              console.log('🔍 Inline event handler added:', mutation.attributeName, mutation.target);
            }
          });
        });
        observer.observe(document.body, {
          attributes: true,
          subtree: true,
          attributeFilter: ['onclick', 'onsubmit', 'onload', 'onerror', 'onchange', 'onfocus', 'onblur']
        });
        this.mutationObserver = observer;
      }
      console.log('🚀 Global custom event monitoring is now active!');
    }

    // Clean up event listeners when section is unloaded
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;
      this.triggers.forEach(function (trigger) {
        trigger.removeEventListener('click', _this2.handleClick);
      });
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.handleOverlayClick);
      }
      document.removeEventListener('keydown', this.handleKeydown);
      document.body.classList.remove('modal-open');

      // Clean up custom event listeners
      this.cleanupCustomEventListeners();

      // Dispatch destruction event
      this.dispatchCustomEvent('formToggle:destroyed', {
        formId: this.formId
      });
    }
  }, {
    key: "cleanupCustomEventListeners",
    value: function cleanupCustomEventListeners() {
      // Restore original methods if they were intercepted
      if (this.originalAddEventListener) {
        EventTarget.prototype.addEventListener = this.originalAddEventListener;
      }
      if (this.originalDispatchEvent) {
        EventTarget.prototype.dispatchEvent = this.originalDispatchEvent;
      }

      // Clean up mutation observer
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      console.log('🛑 Global custom event monitoring has been stopped.');
    }
  }]);
}(); // Initialize FormToggle instances
function initFormToggle() {
  // Clean up existing instances first
  document.querySelectorAll('[data-section-type="form-toggle"]').forEach(function (section) {
    if (section.formToggleInstance) {
      section.formToggleInstance.destroy();
    }
    section.formToggleInstance = new FormToggle(section);
  });
}

// Handle Shopify section events
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('[data-section-type="form-toggle"]')) {
    initFormToggle();
  }
});
document.addEventListener('shopify:section:unload', function (event) {
  var formToggleSection = event.target.querySelector('[data-section-type="form-toggle"]');
  if (formToggleSection && formToggleSection.formToggleInstance) {
    formToggleSection.formToggleInstance.destroy();
    formToggleSection.formToggleInstance = null;
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', initFormToggle);

// Global helper functions for debugging
window.FormToggleDebug = {
  // Enable global event monitoring
  enableGlobalEventMonitoring: function enableGlobalEventMonitoring() {
    document.querySelectorAll('[data-section-type="form-toggle"]').forEach(function (section) {
      if (section.formToggleInstance) {
        section.formToggleInstance.debugMode = true;
        if (!section.formToggleInstance.originalAddEventListener) {
          section.formToggleInstance.interceptAllCustomEvents();
        }
      }
    });
    console.log('🚀 Global event monitoring enabled for all FormToggle instances');
  },
  // Disable global event monitoring
  disableGlobalEventMonitoring: function disableGlobalEventMonitoring() {
    document.querySelectorAll('[data-section-type="form-toggle"]').forEach(function (section) {
      if (section.formToggleInstance) {
        section.formToggleInstance.debugMode = false;
        section.formToggleInstance.cleanupCustomEventListeners();
      }
    });
    console.log('🛑 Global event monitoring disabled for all FormToggle instances');
  },
  // Test by firing a custom event
  testCustomEvent: function testCustomEvent() {
    var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'test:customEvent';
    var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      test: true
    };
    var event = new CustomEvent(eventName, {
      detail: detail,
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
    console.log("\uD83E\uDDEA Test event fired: ".concat(eventName), detail);
  },
  // Get current debug status
  getDebugStatus: function getDebugStatus() {
    var instances = [];
    document.querySelectorAll('[data-section-type="form-toggle"]').forEach(function (section) {
      if (section.formToggleInstance) {
        instances.push({
          formId: section.formToggleInstance.formId,
          debugMode: section.formToggleInstance.debugMode,
          monitoring: !!section.formToggleInstance.originalAddEventListener
        });
      }
    });
    return instances;
  }
};

// Auto-enable monitoring in development
if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev') || window.location.search.includes('debug=true')) {
  console.log('🔧 Development environment detected - auto-enabling global event monitoring');
  setTimeout(function () {
    window.FormToggleDebug.enableGlobalEventMonitoring();
  }, 1000);
}
/******/ })()
;